export default "__VITE_ASSET__be522c8a__"